/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDrsSettleHist.ts                 *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/drs-settle-hist";

export class AutogenModelDrsSettleHist<RowType extends ModelRow> extends Endpoint<RowType, RowDrsSettleHistFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDrsSettleHist extends ModelRow<RowDrsSettleHistFields> {
	constructor(values?: Partial<RowDrsSettleHistFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDrsSettleHistFields {
	city_state: string;
	origin_city: string;
	origin_state: string;
}

